import React from "react";
import { Link } from "react-router-dom";

const Register: React.FC = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: "20px",
          boxShadow: "0 15px 35px rgba(0, 0, 0, 0.1)",
          padding: "40px",
          width: "100%",
          maxWidth: "450px",
          position: "relative",
          overflow: "hidden",
          textAlign: "center",
        }}
      >
        {/* Decorative elements */}
        <div
          style={{
            position: "absolute",
            top: "-50px",
            right: "-50px",
            width: "100px",
            height: "100px",
            background: "linear-gradient(45deg, #764ba2, #667eea)",
            borderRadius: "50%",
            opacity: "0.1",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            bottom: "-30px",
            left: "-30px",
            width: "60px",
            height: "60px",
            background: "linear-gradient(45deg, #667eea, #764ba2)",
            borderRadius: "50%",
            opacity: "0.1",
          }}
        ></div>

        {/* Header */}
        <div style={{ marginBottom: "30px" }}>
          <div
            style={{
              fontSize: "4em",
              marginBottom: "20px",
            }}
          >
            🔐
          </div>
          <h1
            style={{
              margin: "0 0 15px 0",
              fontSize: "1.8em",
              color: "#333",
              fontWeight: "600",
            }}
          >
            Registration Restricted
          </h1>
          <p
            style={{
              margin: 0,
              color: "#666",
              fontSize: "1em",
              lineHeight: "1.5",
            }}
          >
            Access to D'Asaro Artwork Tracker is by invitation only
          </p>
        </div>

        {/* Main Message */}
        <div
          style={{
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
            border: "2px solid #dee2e6",
            borderRadius: "15px",
            padding: "30px",
            marginBottom: "30px",
          }}
        >
          <div
            style={{
              fontSize: "2.5em",
              marginBottom: "15px",
            }}
          >
            ✉️
          </div>
          <h3
            style={{
              margin: "0 0 15px 0",
              color: "#333",
              fontSize: "1.3em",
              fontWeight: "600",
            }}
          >
            Request Access
          </h3>
          <p
            style={{
              margin: "0 0 20px 0",
              color: "#555",
              fontSize: "1em",
              lineHeight: "1.6",
            }}
          >
            To obtain access to the artwork tracking system, please contact:
          </p>
          <div
            style={{
              background: "white",
              border: "2px solid #667eea",
              borderRadius: "10px",
              padding: "15px",
              marginBottom: "15px",
            }}
          >
            <strong
              style={{
                color: "#667eea",
                fontSize: "1.1em",
                fontWeight: "600",
              }}
            >
              info@algios.dev
            </strong>
          </div>
          <p
            style={{
              margin: 0,
              color: "#666",
              fontSize: "0.9em",
              fontStyle: "italic",
            }}
          >
            Include your name, organization, and reason for requesting access
          </p>
        </div>

        {/* Contact Button */}
        <a
          href="mailto:info@algios.dev?subject=D'Asaro Artwork Tracker - Access Request&body=Hello,%0D%0A%0D%0AI would like to request access to the D'Asaro Artwork Tracker system.%0D%0A%0D%0AName: %0D%0AOrganization: %0D%0AReason for access: %0D%0A%0D%0AThank you."
          style={{
            display: "inline-block",
            width: "calc(100% - 40px)",
            padding: "14px 20px",
            background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
            color: "white",
            textDecoration: "none",
            border: "none",
            borderRadius: "10px",
            fontSize: "1em",
            fontWeight: "600",
            cursor: "pointer",
            transition: "all 0.3s ease",
            marginBottom: "25px",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow =
              "0 8px 25px rgba(40, 167, 69, 0.4)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "none";
          }}
        >
          📧 Send Access Request Email
        </a>

        {/* Footer */}
        <div
          style={{
            borderTop: "1px solid #dee2e6",
            paddingTop: "20px",
          }}
        >
          <p
            style={{
              margin: "0 0 10px 0",
              color: "#666",
              fontSize: "0.9em",
            }}
          >
            Already have an account?
          </p>
          <Link
            to="/login"
            style={{
              color: "#667eea",
              textDecoration: "none",
              fontWeight: "600",
              fontSize: "1em",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.textDecoration = "underline")
            }
            onMouseOut={(e) => (e.currentTarget.style.textDecoration = "none")}
          >
            ← Back to Sign In
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Register;
